import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailActionWarningBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "email-action-warning" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5,10a2.94,2.94,0,0,1,2.608,1.572v0l.419.8A.25.25,0,0,0,21,12.258V1.75a.158.158,0,0,0-.1-.147.162.162,0,0,0-.174.034L12.2,10.164a2.407,2.407,0,0,1-3.4,0L.272,1.637A.159.159,0,0,0,0,1.75v10.5A1.749,1.749,0,0,0,1.751,14H13.467a.25.25,0,0,0,.221-.134l1.2-2.292A2.941,2.941,0,0,1,17.5,10Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.726,9.236a1.094,1.094,0,0,0,1.547,0L19.748.761a.433.433,0,0,0,.106-.447C19.759.027,19.49,0,19.25,0H1.75c-.241,0-.511.027-.6.314a.439.439,0,0,0,.106.447Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.782,12.271h0a1.45,1.45,0,0,0-2.562,0l-5.055,9.634a1.433,1.433,0,0,0,.048,1.409A1.457,1.457,0,0,0,12.445,24H22.556a1.459,1.459,0,0,0,1.234-.687,1.434,1.434,0,0,0,.047-1.408ZM17.5,15.25a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-1.5,0V16A.75.75,0,0,1,17.5,15.25Zm0,7a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.25Z" })
	]
});
export default SvgEmailActionWarningBold;
